
import { useNavigate } from 'react-router-dom';

const CTASection = () => {
  const navigate = useNavigate();

  const handleConsultationClick = () => {
    navigate('/consultation');
  };

  const handleBrochureClick = () => {
    navigate('/brochure');
  };

  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-white mb-6">
          Ready to Transform Your Operations?
        </h2>
        <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
          Partner with Golden Black to develop customized chemical solutions that drive 
          efficiency, sustainability, and operational excellence in your industry.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={handleConsultationClick}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Request Consultation
          </button>
          <button 
            onClick={handleBrochureClick}
            className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
          >
            Download Brochure
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
